import { IntlShape } from 'react-intl';
import { z } from 'zod';

export const formSchema = (intl: IntlShape) =>
  z.object({
    name: z.string(),
    metadata: z.object({
      manual: z.boolean(),
      name: z.string().min(1, {
        message: intl.formatMessage({
          id: 'features.datasets.settings.error.required',
        }),
      }),
      description: z.string(),
      columnNames: z.record(z.string()),
    }),
  });

export type FormSchema = z.infer<ReturnType<typeof formSchema>>;
